import { reactive, toRefs } from '@vue/composition-api'
import { getBase64 } from '@/utils/util'

const imgField = ['mien', 'avatar', 'pact', 'small', 'indexsmall']

const byte = 1024 * 2 * 1024

export default () => {
  const state = reactive({
    pactList: [], // 手持合同
    smallList: [], // 售后采访头像
    indexsmallList: [], // 售后采访视频图片
    mienList: [], // 主角风采
    avatarList: [], // 头像

    largerList: [], // 大尺寸
    middleList: [], // 中尺寸
    smallsList: [], // 小尺寸

    previewImage: '', // 图片预览
    previewVisible: false, // 图片预览
  })

  const methods = {
    // 选择图片
    handleChange(type, { file, fileList }) {
      const status = fileList[0]?.status
      if (type.includes('indexList')) {
        const [ origin, index, types ] = type.split('_')
        this[`${types}List`] = fileList
        if (status === 'done') {
          this.form.stick[index] = fileList[0].response.data.url
        } else {
          this.form.stick[index] = ''
        }
        return
      }
      this[`${type}List`] = fileList
      if (status === 'done') {
        this.form[type] = fileList[0].response.data.url
      } else {
        this.form[type] = ''
      }
    },
    handleBeforeUpload(file, type) {
      const size = file.size
      const ends = file.name.substring(file.name.lastIndexOf('.') + 1)
      if ((size > byte) || !['jpg', 'jpeg', 'png'].includes(ends)) {
        if (size > byte) {
          this.$message.warning('图片超出2M咯!')
        } else {
          this.$message.warning('图片格式不正确!')
        }
        setTimeout(() => {
          if (type.includes('indexList')) {
            const [ origin, index, types ] = type.split('_')
            this[`${types}List`] = []
          }
          this[`${type}List`] = []
        })
        return false
      }
      return true
    },
    handleEchoImg(data, qi_niu_domains) {
      // 支持自定义域名（根据接口返回的域名+图片地址）
      const _domains = qi_niu_domains || this.QI_NIU_DOMAINS
      for (const key in data) {
        const item = data[key]
        if (imgField.includes(key) && item) {
          state[`${key}List`].push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${_domains}/${item}` })
        }
        if (key === 'stick') {
          item.forEach((o, i) => {
            switch (i) {
              case 0:
                o && state.largerList.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${_domains}/${o}` })
                break
              case 1:
                o && state.middleList.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${_domains}/${o}` })
                break
              case 2:
                o && state.smallsList.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${_domains}/${o}` })
                break
            }
          })
        }
      }
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    }
  }

  return {
    ...toRefs(state),
    ...methods
  }
}
